import { render } from "./SendEmail.vue?vue&type=template&id=36007c1e&scoped=true"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"

import "./SendEmail.vue?vue&type=style&index=0&id=36007c1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36007c1e"]])

export default __exports__